import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';

const preloadedState = {};

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');

  middlewares.push(logger);
}

export default createStore(
  reducers,
  preloadedState,
  applyMiddleware(...middlewares)
);



// WEBPACK FOOTER //
// ./src/store.js